import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Jumbotron, Container, Button, CardDeck, Card } from 'react-bootstrap';

import Requisites from './Requisites';
import Payment from './Payment';
import Delivery from './Delivery';
import Privacypolicy from './Privacypolicy';
import Publicoffer from './Publicoffer';
import Useragreement from './Useragreement';
import Certificates from './Certificates';
import Guarantee from './Guarantee';


class Documents extends Component {
  render() {
    return (
      <>
        <Jumbotron>
          {this.props.match.params.name === 'requisites' ?
            <h1>Реквизиты</h1>
            : this.props.match.params.name === 'payment' ? 
            <h1>Оплата</h1>
            : this.props.match.params.name === 'delivery' ? 
            <h1>Доставка</h1>
            : this.props.match.params.name === 'privacy_policy' ? 
            <h1>Политика приватности</h1>
            : this.props.match.params.name === 'public_offer' ? 
            <h1>Публичная оферта</h1>
            : this.props.match.params.name === 'user_agreement' ? 
            <h1>Соглашение с конечным пользователем</h1>
            : this.props.match.params.name === 'certificates' ? 
            <h1>Сертификаты</h1>
            : this.props.match.params.name === 'guarantee' ? 
            <h1>Гарантия</h1>
            : <h1>Документация</h1>
          }
          <h2>Указанные в данном разделе документы являются официальными и имеют юридическую силу</h2>
          <p>Пользуясь сайтом Вы соглашаетесь со всеми указанными в документах пунктами.</p>
        </Jumbotron>
        <Container>
        {this.props.match.params.name === 'requisites' ?
        <Requisites/>
        : this.props.match.params.name === 'payment' ?
        <Payment/>
        : this.props.match.params.name === 'delivery' ?
        <Delivery/>
        : this.props.match.params.name === 'privacy_policy' ?
        <Privacypolicy/>
        : this.props.match.params.name === 'public_offer' ?
        <Publicoffer/>
        : this.props.match.params.name === 'user_agreement' ?
        <Useragreement/>
        : this.props.match.params.name === 'certificates' ?
        <Certificates/>
        : this.props.match.params.name === 'guarantee' ?
        <Guarantee/>
        :
        <p>Пользуясь сайтом Вы соглашаетесь со всеми указанными в документах пунктами.</p>
        }
          <CardDeck as="div" className="row">
            <Card as="div" className="col-6 col-md-4 px-0">
              <Card.Img variant="top" src="holder.js/100px160" />
              <Card.Body>
                <Card.Title>Реквизиты</Card.Title>
                <Card.Text>
                  В данном разделе Вы найдете всю необходимую для документооборота информацию о компании
                </Card.Text>
                <small className="text-muted">Обновлено: 01.04.2021</small>
              </Card.Body>
              <Card.Footer className="justify-content-between">
                <Button variant="primary" block href="/documents/requisites">Читать</Button>
              </Card.Footer>
            </Card>
            <Card as="div" className="col-6 col-md-4 px-0">
              <Card.Img variant="top" src="holder.js/100px160" />
              <Card.Body>
                <Card.Title>Оплата</Card.Title>
                <Card.Text>
                  Способы оплаты и покупки. Наличными, безналичными, онлайн, офлайн, кредит, лизинг, выкуп, рассрочка (0%).
                </Card.Text>
                <small className="text-muted">Обновлено: 01.04.2021</small>
              </Card.Body>
              <Card.Footer className="justify-content-between">
                <Button variant="primary" block href="/documents/payment">Читать</Button>
              </Card.Footer>
            </Card>
            <Card as="div" className="col-6 col-md-4 px-0">
              <Card.Img variant="top" src="holder.js/100px160" />
              <Card.Body>
                <Card.Title>Доставка</Card.Title>
                <Card.Text>
                  Вся информация о доставке. Сроки поставки(доставки), цены и объем.
                </Card.Text>
                <small className="text-muted">Обновлено: 01.04.2021</small>
              </Card.Body>
              <Card.Footer className="justify-content-between">
                <Button variant="primary" block href="/documents/delivery">Читать</Button>
              </Card.Footer>
            </Card>
          </CardDeck>
          <CardDeck as="div" className="row my-5">
            <Card as="div" className="col-6 col-md-4 px-0">
              <Card.Img variant="top" src="holder.js/100px160" />
              <Card.Body>
                <Card.Title>Политика приватности</Card.Title>
                <Card.Text>
                  Документ регулирующий условия сбора, хранения и использования Вашей персональной информации. На любой стадии сбора информации, Вы будете осведомлены о собираемых данных. Обычно это только электронная почта, имя и номер телефона.
                </Card.Text>
                <small className="text-muted">Обновлено: 01.04.2021</small>
              </Card.Body>
              <Card.Footer className="justify-content-between">
                <Button variant="primary" block href="/documents/privacy_policy">Читать</Button>
              </Card.Footer>
            </Card>
            <Card as="div" className="col-6 col-md-4 px-0">
              <Card.Img variant="top" src="holder.js/100px160" />
              <Card.Body>
                <Card.Title>Публичная оферта</Card.Title>
                <Card.Text>
                  Публичное предложение о заключении договора, сделки для всех лиц, посетивших данный ресурс. Не является соглашением с конечным пользователем.
                </Card.Text>
                <small className="text-muted">Обновлено: 01.04.2021</small>
              </Card.Body>
              <Card.Footer className="justify-content-between">
                <Button variant="primary" block href="/documents/public_offer">Читать</Button>
              </Card.Footer>
            </Card>
            <Card as="div" className="col-6 col-md-4 px-0">
              <Card.Img variant="top" src="holder.js/100px160" />
              <Card.Body>
                <Card.Title>Соглашение с конечным пользователем</Card.Title>
                <Card.Text>
                  Соглашение о пользовании сайтом с конечным пользователем. Регулирует права пользования ресурсом и запрещает взлом.
                </Card.Text>
                <small className="text-muted">Обновлено: 01.04.2021</small>
              </Card.Body>
              <Card.Footer className="justify-content-between">
                <Button variant="primary" block href="/documents/user_agreement">Читать</Button>
              </Card.Footer>
            </Card>
          </CardDeck>
          <CardDeck as="div" className="row">
            <Card as="div" className="col-6 col-md-4 px-0">
              <Card.Img variant="top" src="holder.js/100px160" />
              <Card.Body>
                <Card.Title>Сертификаты</Card.Title>
                <Card.Text>
                  Сертификаты соответствия указанных на ресурсе позиции.
                </Card.Text>
                <small className="text-muted">Обновлено: 01.04.2021</small>
              </Card.Body>
              <Card.Footer className="justify-content-between">
                <Button variant="primary" block href="/documents/certificates">Читать</Button>
              </Card.Footer>
            </Card>
          </CardDeck>
        </Container>
      </>
    );
  };
};


Documents.propTypes = {
    // fetchPosts: PropTypes.func.isRequired,
    // posts: PropTypes.array.isRequired,
    // fetchReviews: PropTypes.func.isRequired,
    // reviews: PropTypes.array.isRequired,
    // fetchCarCats: PropTypes.array.isRequired,
    // carCats: PropTypes.array.isRequired,
    // fetchCarCat: PropTypes.array.isRequired,
    // carCat: PropTypes.array.isRequired,
    // fetchCars: PropTypes.array.isRequired,
    // cars: PropTypes.array.isRequired,
    // fetchCar: PropTypes.array.isRequired,
    // car: PropTypes.array.isRequired,
}

const mapStateToProps = state => ({
    posts: state.posts.items,
    reviews: state.reviews.items,
    carcats: state.cars.carcats,
    carcat: state.cars.carcat,
    cars: state.cars.cars,
    car: state.cars.car,
    tehcats: state.teh.tehcats,
    tehcat: state.teh.tehcat,
    tehs: state.teh.tehs,
    teh: state.teh.teh,
});

export default connect(mapStateToProps, {  })(Documents);
